import { zod } from "@/BaseComponent";

const regexForPassword = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_\+\-=\[\]{}|;:'",.<>?/])[A-Za-z\d!@#$%^&*()_\+\-=\[\]{}|;:'",.<>?/]{8,}$/;

export default {
    add: zod
        .object({
            name: zod.string().min(2, "이름을 2글자 이상 입력해주세요").max(15, "이름은 최대 15글자까지 사용가능합니다."),
            id: zod.string().min(3, "아이디를 3글자 이상 입력해주세요.").max(20, "아이디는 최대 20글자까지 가능합니다."),
            pw: zod.string().regex(regexForPassword, "비밀번호는 소문자, 숫자, 특수문자를 포함한 8자 이상이어야 합니다."),
            pw_re: zod.string().min(1, "비밀번호 확인을 입력해주세요"),
            auas: zod.string().min(1, "담당 내용을 입력해주세요").max(100, "담당 내용은 최대 100자까지 입력 가능합니다."),
            dept: zod.number().refine((value) => [1, 3, 5, 6].includes(value), "잘못된 부서가 선택되었습니다."),
            auth: zod.number().refine((value) => [5, 6, 7, 8].includes(value), "잘못된 권한이 선택되었습니다."),
        })
        .refine((data) => data.pw && data.pw_re && data.pw === data.pw_re, "비밀번호가 다릅니다"),

    edit: zod
        .object({
            name: zod.string().min(2, "이름을 2글자 이상 입력해주세요").max(15, "이름은 최대 15글자까지 사용가능합니다."),
            id: zod.string().min(3, "아이디를 3글자 이상 입력해주세요.").max(20, "아이디는 최대 20글자까지 가능합니다."),
            pw: zod.string().regex(regexForPassword, "비밀번호는 소문자, 숫자, 특수문자를 포함한 8자 이상이어야 합니다.").or(zod.literal("")),
            pw_re: zod.string().min(1, "비밀번호 확인을 입력해주세요").or(zod.literal("")),
            auas: zod.string().min(1, "담당 내용을 입력해주세요").max(100, "담당 내용은 최대 100자까지 입력 가능합니다."),
            dept: zod.number().refine((value) => [1, 3, 5, 6].includes(value), "잘못된 부서가 선택되었습니다."),
            auth: zod.number().refine((value) => [5, 6, 7, 8].includes(value), "잘못된 권한이 선택되었습니다."),
        })
        .refine((data) => (!data.pw && !data.pw_re) || data.pw === data.pw_re, "비밀번호가 다릅니다"),
};
